module.exports = __webpack_public_path__ + "rw-widgets.eot";


//////////////////
// WEBPACK FOOTER
// ./~/react-widgets/lib/fonts/rw-widgets.eot?v=4.1.0
// module id = 790
// module chunks = 0